@use '../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../styles/Constants.scss' as Constants;

.section {
	padding: Constants.$val-spacing-m;
	background-color: Colors.$col-white;
	box-shadow: Constants.$val-boxShadow;
	margin-bottom: Constants.$val-spacing-s;
}

.label {
	color: Colors.$col-design-grey15;
	padding: Constants.$val-spacing-s;
	padding-left: 0;
	padding-top: Constants.$val-spacing-s;
}

.value {
	padding-left: Constants.$val-spacing-s;
	padding-top: Constants.$val-spacing-s;
	padding-bottom: Constants.$val-spacing-s;
}

.title {
	font-size: Constants.$val-fontSizeBig;
	text-transform: uppercase;
	color: Colors.$col-greyFontLight;
	margin-bottom: Constants.$val-spacing-s;
}

.header {
	font-size: Constants.$val-fontSizeXBig;
	text-transform: uppercase;
	font-weight: bold;
}

.header-info {
	display: flex;
	justify-content: space-between;
	flex-direction: row;
}

.item-info-container {
	display: flex;
	flex-direction: row;
}

.item-info {
	width: 100%;
}

.categories {
	display: flex;
	flex-direction: row;
	gap: Constants.$val-spacing-s;
}

.danger {
	color: Colors.$col-red;
}

.restock {
	color: Colors.$col-greyFontLight;
	padding: Constants.$val-spacing-s;
	margin-bottom: Constants.$val-spacing-m;
}

.minimal-quantity-danger {
	font-weight: bold;
	display:flex;
	flex-direction: row;
}

.minimal-value {
 margin-left: Constants.$val-spacing-s;
}

.order-status {
	font-weight: 700;
	background-color: Colors.$col-design-grey13;
	font-size: Constants.$val-fontSizeSmall;
	line-height: Constants.$val-lineHeightSmall;
	min-width: 100px;
	padding: Constants.$val-spacing-xs;

	display: grid;
	place-content: center;

	&--new {
		color: Colors.$col-blue;
	}

	&--in-progress {
		color: Colors.$col-orangeBorder;
	}

	&--completed {
		color: Colors.$col-green;
	}
}